(function () {
  angular.module("akitabox.workOrder").run(states);

  /* @ngInject */
  function states(models, Router) {
    Router.configureStates([
      {
        state: "app.workOrders",
        config: {
          abstract: true,
          url: "/" + models.WORK_ORDER.ROUTE_PLURAL,
          template: '<div flex layout="column" layout-fill ui-view ></div>',
        },
      },
      {
        state: "app.workOrders.my",
        config: {
          url: "?status&q",
          templateUrl: "app/mobile/modules/work-order/my-list/my-list.html",
          controller: "MyWorkOrderListController",
          controllerAs: "vm",
          reloadOnSearch: false,
          resolve: {
            query: getQuery,
            status: getStatus,
          },
          data: {
            pageTitle: "My Work Orders",
          },
        },
      },
      {
        state: "app.building.workOrder",
        config: {
          abstract: true,
          url: "/" + models.WORK_ORDER.ROUTE_PLURAL + "/:workOrderId",
          template: '<div flex layout="column" layout-fill ui-view ></div>',
          resolve: {
            workOrder: getWorkOrder,
          },
        },
      },
      {
        state: "app.building.workOrders",
        config: {
          url: "/" + models.WORK_ORDER.ROUTE_PLURAL + "?status&q",
          templateUrl:
            "app/mobile/modules/work-order/building-list/buildingList.html",
          controller: "WorkOrderBuildingListController",
          controllerAs: "vm",
          reloadOnSearch: false,
          resolve: {
            query: getQuery,
            status: getStatus,
          },
          data: {
            pageTitle: "Work Orders",
          },
        },
      },
    ]);
  }

  // ------------------------
  //   Detail
  // ------------------------

  /** @ngInject */
  function getWorkOrder(
    /* Third-party */
    $stateParams,
    /* Resolve */
    account,
    building,
    /* Services */
    WorkOrderService
  ) {
    // This is a check for the special case of coming form a create route
    // Since we already have the new object, we don't want pull from the server
    // So check if the work order object is the correct one
    if (
      $stateParams.workOrder &&
      $stateParams.workOrder._id === $stateParams.workOrderId
    ) {
      return $stateParams.workOrder;
    }

    // The normal entry point
    return WorkOrderService.getById(building._id, $stateParams.workOrderId);
  }

  // ------------------------
  //   List
  // ------------------------

  /** @ngInject */
  function getQuery(account, $stateParams) {
    return $stateParams.q;
  }

  /** @ngInject */
  function getStatus(account, $stateParams) {
    var validStatuses = ["open", "closed"];
    if (
      angular.isEmpty($stateParams.status) ||
      validStatuses.indexOf($stateParams.status) === -1
    ) {
      $stateParams.status = "open";
    }
    return $stateParams.status;
  }
})();
